import AppBrand from "./app-brand";
import QCode from "./qrcode";
export default { AppBrand, QCode };
